import { FC } from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectIsSocialCampaign, selectIsUnlockedCampaign } from '@store/campaigns'
import {
  selectCurrentDeclinedFilter,
  selectIsBCAFilter,
  selectIsDeclinedFilter,
} from '@store/router'
import SubmissionCardListEmptyBrandedContentAd from './BrandedContentAd'
import SubmissionCardListEmptyDeclined from './Declined'
import SubmissionCardListEmptyDefault from './Default'

interface IProps {
  submissionFilter: string
  campaignId: number
}

const SubmissionCardListEmpty: FC<IProps> = ({ submissionFilter, campaignId }) => {
  const {
    declinedFilter,
    isBCAFilter,
    isDeclinedListFilter,
    isUnlockedCampaign,
    isSocialCampaign,
  } = useSelector((state: IApplicationState) => ({
    isBCAFilter: selectIsBCAFilter(state),
    isDeclinedListFilter: selectIsDeclinedFilter(state),
    declinedFilter: selectCurrentDeclinedFilter(state),
    isUnlockedCampaign: selectIsUnlockedCampaign(state, campaignId),
    isSocialCampaign: selectIsSocialCampaign(state, campaignId),
  }), shallowEqual)
  if (isBCAFilter) {
    return <SubmissionCardListEmptyBrandedContentAd />
  }

  if (isDeclinedListFilter) {
    return <SubmissionCardListEmptyDeclined declinedFilter={declinedFilter} />
  }

  return (
    <SubmissionCardListEmptyDefault
      submissionFilter={submissionFilter}
      isUnlocked={isUnlockedCampaign}
      isSocialCampaign={isSocialCampaign}
    />
  )
}

export default SubmissionCardListEmpty
